import { API_METHODS, createApiFunction } from './apiProvider'

const PATH = 'address'

export const saveAddressApi = (address) =>
  createApiFunction(API_METHODS.POST, PATH, address, true)
